import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import BillingCompanyModal from '../components/billingSettings/BillingCompanyModal';
import { createBillingCompany, initializeDefaultBillingCompanies, subscribeBillingCompanies, updateBillingCompany } from '../services/billingService';

export default function BillingSettings() {
  const { userData } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [editing, setEditing] = useState(null);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const isAdmin = String(userData?.role || '').toLowerCase() === 'admin';

  useEffect(() => subscribeBillingCompanies(setCompanies, (err) => setError(err.message)), []);
  if (!isAdmin) return <div className="bg-white p-8 rounded shadow"><h1 className="text-2xl font-bold">Billing Settings</h1><p className="text-red-700 mt-2">Only Admin can manage billing settings.</p></div>;

  const save = async (values) => {
    try {
      if (editing) await updateBillingCompany(editing.id, values, userData);
      else await createBillingCompany(values, userData);
      setOpen(false); setEditing(null); setMessage('Billing company saved.'); setError('');
    } catch (err) { setError(`Could not save company: ${err.message}`); }
  };

  const initialize = async () => {
    try {
      const count = await initializeDefaultBillingCompanies(companies, userData);
      setMessage(count ? `${count} default billing companies added.` : 'Default billing companies already exist.');
    } catch (err) { setError(`Could not initialize companies: ${err.message}`); }
  };

  return <div>
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 mb-4">
      <div><h1 className="text-2xl font-bold">Billing Settings</h1><p className="text-sm text-gray-500">Configure billing entities, GST and numbering.</p></div>
      <div className="flex gap-2"><button onClick={initialize} className="px-4 py-2 bg-gray-700 text-white rounded">Initialize Defaults</button><button onClick={() => { setEditing(null); setOpen(true); }} className="px-4 py-2 bg-blue-600 text-white rounded">+ Add Company</button></div>
    </div>
    {error && <div className="mb-4 p-3 bg-red-100 text-red-800 rounded">{error}</div>}
    {message && <div className="mb-4 p-3 bg-green-100 text-green-800 rounded">{message}</div>}
    <div className="bg-white rounded shadow overflow-x-auto">
      <table className="w-full text-sm"><thead className="bg-gray-100"><tr><th className="text-left p-3">Company</th><th className="text-left p-3">PAN / GSTIN</th><th className="text-left p-3">GST</th><th className="text-left p-3">Prefix</th><th className="text-left p-3">Status</th><th className="text-right p-3">Action</th></tr></thead>
      <tbody>{companies.map((company) => <tr key={company.id} className="border-t"><td className="p-3"><div className="font-semibold">{company.name}</div></td><td className="p-3"><div>{company.pan || 'No PAN'}</div><div className="text-xs text-gray-500">{company.gstin || 'No GSTIN'}</div></td><td className="p-3">{company.gstApplicable ? `${company.gstRate || 18}%` : 'Not applicable'}</td><td className="p-3 font-mono">{company.prefix}</td><td className="p-3">{company.isActive === false ? 'Inactive' : 'Active'}</td><td className="p-3 text-right"><button onClick={() => { setEditing(company); setOpen(true); }} className="text-blue-700">Edit</button></td></tr>)}</tbody></table>
      {!companies.length && <div className="p-8 text-center text-gray-500">No billing companies configured.</div>}
    </div>
    <BillingCompanyModal open={open} company={editing} onClose={() => { setOpen(false); setEditing(null); }} onSave={save} />
  </div>;
}
